import PageWrapper from "../../PageWrapper";
import CreateQRCodeView from "../../../components/qr-code/create/CreateQRCodeView";

/**
 * Create QR code page.
 * @route /qr-code/create
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function CreateQRCode() {
    return (
        <PageWrapper container subPage>
            <CreateQRCodeView/>
        </PageWrapper>
    );
}

export default CreateQRCode;

// TODO: CreateQRCode.tsx [qr-code/create]
//  Implement page.